import { logFormData } from 'shared/lib/logFormData';

import type { TContactsFormFields } from 'entities/creditForm';
import { sendStepsAnalyticsEvents, setContactsInfo } from 'entities/creditForm';

import { ContactsInfoTexts } from 'features/UpdateContactsInfo/ContactsInfo.texts';

export const submitContactsForm =
  (actualData: TContactsFormFields): ThunkResult<void> =>
  async (dispatch) => {
    dispatch(setContactsInfo({ data: actualData, isFullFilled: true }));
    logFormData('ContactsInfo FormStep SubmitData', actualData);
    dispatch(sendStepsAnalyticsEvents([1], ContactsInfoTexts, 'manual'));
  };
